/**
 * @public
 */
export class Tag {
    constructor() { }
    equals(value) {
        return value instanceof Tag && value.type === this.type;
    }
    toJSON() {
        return {
            type: this.type,
        };
    }
}
/**
 * @public
 */
(function (Tag) {
    function isTag(value, type) {
        return value instanceof Tag && (type === undefined || value.type === type);
    }
    Tag.isTag = isTag;
})(Tag || (Tag = {}));
//# sourceMappingURL=tag.js.map